import Store from 'redux/store';
import { ACTIONS_TYPES } from 'redux/helper';
import { getConfig } from './config';
import { getSessionKey, getParam } from '.';
import { setSessionKey } from './utils';

const checkFeatureInContract = (featureName) => {
  const { [ACTIONS_TYPES.COMMON.GET_FEATURES]: features = [] } = Store.getState();
  return features.includes(featureName);
};

const isFeatureExistInParam = (feature) => {
  let hasInQuery = getSessionKey(`feature-${feature}`);
  if (!hasInQuery && getParam(feature)) {
    hasInQuery = true;
    setSessionKey(`feature-${feature}`, true);
  }
  return hasInQuery;
};

const isFeatureExistInConfig = (featureName) => {
  const { features = {} } = getConfig() || {};
  const existInConfig = features[featureName];
  const existInParam = isFeatureExistInParam(featureName);
  return existInConfig || existInParam;
};

const isFeatureExistInContract = (featureName) => {
  const isExistInConfig = isFeatureExistInConfig(featureName);
  const isExistInContract = checkFeatureInContract(featureName);
  return isExistInConfig && isExistInContract;
};

export const featuresToggle = {
  isMonitoring: () => isFeatureExistInContract('monitoring'),
  isAutoScaling: () => isFeatureExistInContract('vm-autoscaling'),
  isAdServer: () => isFeatureExistInConfig('ad-server'),
  isDatabases: () => isFeatureExistInConfig('databases'),
  isALB: () => isFeatureExistInConfig('alb'),
  isSampleData: () => isFeatureExistInConfig('isSampleData'),
  isExistInConfig: (featureName) => isFeatureExistInConfig(featureName),
  isExistInContract: (featureName) => isFeatureExistInContract(featureName),
  isExistInDatacenter: (datacenter, featureName) => (datacenter?.properties?.features || []).includes(featureName),
  isContainerRegistry: () => isFeatureExistInConfig('container-registry'),
  isMongoDB: () => isFeatureExistInConfig('mongodb'),
};
